/* template */
<template minapp="mpx" xlang="wxml"><es-card :layout="(['header'])" custom-header="es-content__miniapp_card_header" custom-body="es-content__miniapp_card_body"><div slot="header" class="child-card-title"><div>儿童购票说明</div><mpx-view @tap="jumpToComment" class="child-card-more">更多说明<es-icon size="16" name="angle-right" color="#212121" class="es-content__name-info"/></mpx-view></div><div class="child-card-list"><div v-for="(item, index) in (childList)" class="child-card-item"><div class="child-card-text" v-if="(item.type === 'text')"><span v-for="(textItem, index) in (item.value)" :class="(textItem.highLight ? 'child-card-text-highlight' : '')">{{textItem.text}}</span></div><div class="child-card-table" v-if="(item.type === 'table')"><div v-for="(tItem, index) in (item.value)" :class='("child-card-table-item "+(index > 0 ? "child-card-tr" : "child-card-th"))'><div v-for="(vItem, index) in (tItem)" class="child-card-vItem">{{vItem}}</div></div></div></div></div></es-card></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m1c36874f"}'>
.child-card
  &-list
    margin-top 12px
  &-title
    display flex
    align-items center
    justify-content space-between
  &-more
    display flex
    align-items center
    font-weight 400
    font-size 12px
  &-text
    color #666
    font-size 14px
    margin-bottom 12px
    line-height 18px
    word-break break-all
    &-highlight
      color #FF7D41
  &-table
    border 1px solid rgba(0, 0, 0, 0.08)
    border-radius 6px
    margin-bottom 12px
    &-item
      display flex
      height 32px
      line-height 32px
      border-bottom 1px solid rgba(0, 0, 0, 0.08)
      &:last-child
        border-bottom 0
  &-th
    background rgba(231, 241, 255, 0.3)
    font-family PingFangSC-Medium
  &-tr
    font-family PingFangSC-Regular
  &-vItem
    font-size 12px
    border-right 1px solid rgba(0, 0, 0, 0.08)
    border-collapse collapse
    padding 8px 0 8px 12px
    display flex
    align-items center
    color #666
    &:nth-child(1)
      flex 1.7
    &:nth-child(2)
      flex 1
    &:nth-child(3)
      flex 1
    &:last-child
      flex 1.2
      border-right 0
  
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1c36874f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./child-card.mpx.js?isComponent&outputPath=components%2Fchild-card1c36874f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./child-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchild-card1c36874f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m1c36874f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/child-card1c36874f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-card':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/card/index.mpx?isComponent&outputPath=components%2Findex340a2e8c%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
